import { render, staticRenderFns } from "./SettingFeedSection.vue?vue&type=template&id=74a0e423"
import script from "./SettingFeedSection.vue?vue&type=script&lang=js"
export * from "./SettingFeedSection.vue?vue&type=script&lang=js"
import style0 from "./SettingFeedSection.vue?vue&type=style&index=0&id=74a0e423&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports